export default __webpack_public_path__ + "static/media/oxxo-logo.353ddd8f.png";